var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Assets",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Outline Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contract"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17108",
    "data-name": "Group 17108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17107",
    "data-name": "Group 17107"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19108",
    "data-name": "Path 19108",
    d: "M29.172,10.852a2.445,2.445,0,0,0-3.449,0L23.271,13.3V6.853a2.425,2.425,0,0,0-.715-1.724l-2.3-2.3a2.423,2.423,0,0,0-1.73-.72H4.55A2.444,2.444,0,0,0,2.109,4.55v22.9A2.444,2.444,0,0,0,4.55,29.89H20.836a2.443,2.443,0,0,0,2.44-2.44V20.213l5.9-5.907a2.44,2.44,0,0,0,0-3.452ZM18.387,3.738a.886.886,0,0,1,.715.238l2.3,2.3a.887.887,0,0,1,.237.714H18.381ZM21.644,27.45a.815.815,0,0,1-.814.814H4.544a.815.815,0,0,1-.814-.814h0V4.55a.815.815,0,0,1,.816-.812H16.758v4.07a.815.815,0,0,0,.815.814h4.069v6.311l-2.4,2.4-1.149,1.15a.819.819,0,0,0-.192.318l-1.149,3.449a.814.814,0,0,0,.517,1.029.829.829,0,0,0,.512,0l3.448-1.15a.793.793,0,0,0,.318-.192l.1-.1v5.608Zm-1.826-8.388,1.15,1.149-.439.439-1.724.575.574-1.725Zm2.3,0-1.149-1.15,3.906-3.924,1.15,1.15Zm5.9-5.907-.845.833-1.149-1.149L26.863,12a.814.814,0,1,1,1.217,1.081.861.861,0,0,1-.067.068Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17110",
    "data-name": "Group 17110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17109",
    "data-name": "Group 17109"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19109",
    "data-name": "Path 19109",
    d: "M18.057,12.164H8a.82.82,0,0,0,0,1.629H18.057a.82.82,0,0,0,0-1.629Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_17112",
    "data-name": "Group 17112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17111",
    "data-name": "Group 17111"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19110",
    "data-name": "Path 19110",
    d: "M16.059,16.479H8.079a.815.815,0,0,0,0,1.629h7.98a.815.815,0,0,0,0-1.629Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.1562a79f23d079bcab70997bc000cb83.svg";
export { ForwardRef as ReactComponent };